import type { BatteryLevel } from './energy-view';

const BODY =
  'M2 12C2 9.17157 2 7.75736 2.87868 6.87868C3.75736 6 5.17157 6 8 6H13C15.8284 6 17.2426 6 18.1213 6.87868C19 7.75736 19 9.17157 19 12C19 14.8284 19 16.2426 18.1213 17.1213C17.2426 18 15.8284 18 13 18H8C5.17157 18 3.75736 18 2.87868 17.1213C2 16.2426 2 14.8284 2 12Z';
const CAP =
  'M19 9.5L20.0272 9.6712C20.7085 9.78475 21.0491 9.84152 21.3076 10.0067C21.5618 10.1691 21.7612 10.4044 21.8796 10.6819C22 10.964 22 11.3093 22 12C22 12.6907 22 13.036 21.8796 13.3181C21.7612 13.5956 21.5618 13.8309 21.3076 13.9933C21.0491 14.1585 20.7085 14.2153 20.0272 14.3288L19 14.5';
const BARS = ['M6 10V14', 'M9 10V14', 'M12 10V14', 'M15 10V14'];
const INFINITY =
  'M10.5 12C9.5 10.6667 8.66667 10 8 10C6.89543 10 6 10.8954 6 12C6 13.1046 6.89543 14 8 14C8.66667 14 9.5 13.3333 10.5 12ZM10.5 12C11.5 13.3333 12.3333 14 13 14C14.1046 14 15 13.1046 15 12C15 10.8954 14.1046 10 13 10C12.3333 10 11.5 10.6667 10.5 12Z';
const CHARGING = 'M10.83 9L9.09 11.17C8.9 11.41 9.03 11.74 9.34 11.81L11.16 12.18C11.49 12.24 11.61 12.61 11.38 12.84L9.22 15';
const BOLT = 'M13 2.5L5 13.5H11.5L10.5 21.5L19 10.5H12.5L13 2.5Z';

/**
 * A battery outline with `level` bars filled left to right, a bolt while the Joule balance is spent, or an infinity
 * sign for the comped unlimited Energy, drawn in the caller's text color.
 */
export const BatteryIcon = ({
  level,
  size = 18,
  className,
}: {
  level: BatteryLevel | 'charging' | 'unlimited';
  size?: number;
  className?: string;
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    className={className}
    aria-hidden="true"
  >
    <path d={BODY} />
    <path d={CAP} />
    {level === 'unlimited' && <path d={INFINITY} />}
    {level === 'charging' && <path d={CHARGING} strokeLinejoin="round" />}
    {typeof level === 'number' && BARS.slice(0, level).map((bar) => <path key={bar} d={bar} />)}
  </svg>
);

/** A lightning bolt for the Joule balance (Recharge), drawn in the caller's text color. */
export const RechargeIcon = ({ size = 18, className }: { size?: number; className?: string }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d={BOLT} />
  </svg>
);
